import React, {FC, memo} from "react";
import {Badge, Tooltip} from "antd";
import css from "./SuperUserBadge.less";

type SuperUserBadgeProps = {
    message?: string;
    children: React.ReactNode;
    placement?:
        | "top"
        | "left"
        | "right"
        | "bottom"
        | "topLeft"
        | "topRight"
        | "bottomLeft"
        | "bottomRight"
        | "leftTop"
        | "leftBottom"
        | "rightTop"
        | "rightBottom";
};

const SuperUserBadge: FC<SuperUserBadgeProps> = ({
    message = "",
    children,
    placement,
}) => {
    const actualMessage = message ? message : "Nur für Super User sichtbar";

    return (
        <Tooltip title={actualMessage} placement={placement}>
            <Badge dot color="pink">
                {children}
            </Badge>
        </Tooltip>
    );
};

export default memo(SuperUserBadge);
